import { useEffect, useState } from "react";
import { cachedCaptureBlocked, ENTITLEMENT_CHANGED } from "@/lib/entitlement";
import { getSyncStatus, subscribeSync } from "@/lib/sync";

export const LAPSE_REFRESH_MS = 60_000;

/** Cache-only capture gate and the server's held-row count. */
export function useLapse(): { captureBlocked: boolean; held: number; isCaptureBlocked: () => boolean } {
  const [captureBlocked, setCaptureBlocked] = useState(cachedCaptureBlocked);
  const [held, setHeld] = useState(() => getSyncStatus().held);
  useEffect(() => {
    const update = () => setCaptureBlocked(cachedCaptureBlocked());
    window.addEventListener(ENTITLEMENT_CHANGED, update);
    window.addEventListener("online", update);
    window.addEventListener("offline", update);
    const timer = window.setInterval(update, LAPSE_REFRESH_MS);
    const unsubscribe = subscribeSync((status) => setHeld(status.held));
    return () => {
      window.removeEventListener(ENTITLEMENT_CHANGED, update);
      window.removeEventListener("online", update);
      window.removeEventListener("offline", update);
      window.clearInterval(timer);
      unsubscribe();
    };
  }, []);
  return { captureBlocked, held, isCaptureBlocked: cachedCaptureBlocked };
}
